"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PropertyCondition_1 = require("./PropertyCondition");
class ArrayCondition extends PropertyCondition_1.PropertyCondition {
    constructor(property, itemCondition) {
        super(property);
        this.itemCondition = itemCondition;
    }
    setOptions(options) {
        super.setOptions(options);
        this.itemCondition.setOptions(options);
    }
    isFulfilled(value) {
        const superResult = super.checkProperty(value);
        if (superResult.isFinal) {
            return superResult.result;
        }
        const isArray = typeof (value[this.property]) === "object" && value[this.property] instanceof Array;
        if (!isArray) {
            return this.createUnfulfilledResult(value, "is not an array");
        }
        const result = { fulfilled: true, reasons: [] };
        value[this.property].forEach((item, index) => {
            const itemResult = this.itemCondition.isFulfilled(item);
            if (!itemResult.fulfilled) {
                result.fulfilled = false;
                result.reasons = result.reasons.concat(this.prefixPaths(index, itemResult.reasons));
            }
        });
        return result.fulfilled ? { fulfilled: true } : result;
    }
    prefixPaths(index, reasons) {
        return reasons.map((reason) => {
            if (reason.path.length === 0) {
                reason.path = `${this.property}[${index}]`;
            }
            else {
                reason.path = `${this.property}[${index}].${reason.path}`;
            }
            return reason;
        });
    }
}
exports.ArrayCondition = ArrayCondition;
//# sourceMappingURL=ArrayCondition.js.map